import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const createQuote = async ({ quoteNumber, contactId, lineItems }) => {
  const { data: { Quotes } } = await axios.post(`${API_URL}/xero/quotes`, {
    contactId,
    quoteNumber,
    lineItems
  });

  const createdQuote = Quotes[0];

  return createdQuote;
};

const updateQuote = async ({ quoteId, status, date, contactId, lineItems }) => {
  const payload = {};

  if (status) payload.status = status;
  if (lineItems) payload.lineItems = lineItems;
  if (date) payload.date = date;
  if (contactId) payload.contactId = contactId;

  const { data } = await axios.put(`${API_URL}/xero/quotes/${quoteId}`, payload);

  return data;
};

const xeroService = {
  createQuote,
  updateQuote
};

export default xeroService;
